import React from 'react'
import All from './components/All'
import Contact from './components/Contact'
import Team from './components/Team'
import Vehicles from './components/Vehicles'
import Navbar from './components/Navbar'
import About from './components/About'
import Footer from './components/Footer'

import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";




export default function App() {
  

  const displaysidebar=()=>{
    document.querySelector(".container").classList.toggle("change")
  }
  const GoUp=()=>{
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
 
  const linkAction=()=>{
    document.querySelector(".container").classList.toggle("change")
}

  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <div>
            <Navbar linkAction={linkAction} displaysidebar={displaysidebar}/>
            <All displaysidebar={displaysidebar}/>
            <Footer GoUp={GoUp}/>
          </div>
        </Route>
        <Route path="/contact">
          <Navbar linkAction={linkAction} displaysidebar={displaysidebar}/>
          <Contact />
          <Footer GoUp={GoUp}/>
        </Route>
        <Route path="/vehicles">
          <Navbar  linkAction={linkAction} displaysidebar={displaysidebar}/>
          <Vehicles />
          <Footer GoUp={GoUp}/>
        </Route>
        <Route path="/team">
          <Navbar  linkAction={linkAction} displaysidebar={displaysidebar}/>
          <Team />
          <Footer GoUp={GoUp}/>
        </Route>
        <Route path="/about">
          <Navbar  linkAction={linkAction} displaysidebar={displaysidebar}/>
          <About />
          <Footer GoUp={GoUp}/>
        </Route>
      </Switch>
      
    </Router>
    
  )
}



